import { IParamsDto } from 'src/types'

const removeDefaultParams = (params: IParamsDto = {}, defaultParams: IParamsDto) => {
  Object.entries(params).forEach(([key, value]) => {
    if (value === defaultParams[key]) {
      delete params[key]
    }
  })

  return params
}

export { removeDefaultParams }
